module.exports = __webpack_public_path__ + "img/collection-memoireRingsFullSizeMemoires@2x.f7f1350.webp";